export enum BannerPlacement {
  PageTop = 'pageTop',
  VacancyTop = 'vacancyTop'
}

export interface LotriverConfig {
  sid: string;
  bn: string;
  containerId: string;
  containerClassName?: string;
  arCn?: number;
  tagName?: string;
  shouldOffsetHeader?: boolean;
}

export const BANNER_CONFIG: Record<BannerPlacement, LotriverConfig> = {
  [BannerPlacement.PageTop]: {
    sid: '221738',
    bn: '3',
    containerId: 'js-lotriver-desk-top-banner',
    containerClassName: 'lotriver-desk-top-banner',
    arCn: 1,
    shouldOffsetHeader: true
  },

  [BannerPlacement.VacancyTop]: {
    sid: '221738',
    bn: '8',
    containerId: 'js-lotriver-vacancy-top-banner',
    containerClassName: 'lotriver-vacancy-top-banner',
    arCn: 2
  }
};
